import { Injectable } from '@angular/core';
import { environment } from '../../enviroment/enviroment';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, shareReplay, tap, lastValueFrom, catchError, throwError } from 'rxjs';
import { Hosting } from '../models/HostingModel';
import { AuthService } from './auth.service';
import { forkJoin, switchMap } from 'rxjs';

// Interfaz para la respuesta de la API
interface ApiResponse {
  items: Hosting[];
  lastKey?: string;
  hasMore: boolean;
}

// Interfaz para habitaciones ocupadas
interface OccupiedRoom {
  hotel_id: string;
  room_id: string;
}

// Interfaz para la respuesta de habitaciones ocupadas
interface OccupiedRoomsResponse {
  check_in: string;
  check_out: string;
  total_occupied_rooms: number;
  occupied_rooms: OccupiedRoom[];
  message: string;
  usage: string;
}

@Injectable({
  providedIn: 'root',
})
export class HostingService {
  private readonly apiUrl = environment.hostingApiUrl; // URL de la API
  private readonly availabilityUrl = environment.availabilityApiUrl; // URL para consultar disponibilidad
  private readonly cache = new Map<string, Observable<any>>();

  private readonly apiadmin = environment.apiAdmin;
   private readonly apiRecepcion = environment.apiRecep;

  constructor(private readonly http: HttpClient , private readonly authservice:AuthService) {
  }

  // Obtener todos los hostings
  getHostings(limit: number, lastKey?: string): Observable<ApiResponse> {
    const cacheKey = lastKey || 'initial';

    // Retornar observable en cache si existe
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey)!;
    }

    const params = new HttpParams()
      .set('limit', limit.toString())
      .set('lastKey', lastKey || '');

    const request$ = this.http.get<ApiResponse>(this.apiUrl, { params }).pipe(
      shareReplay(1) // Compartir la misma suscripción
    );

    this.cache.set(cacheKey, request$);
    return request$;
  }



  getHostingsByid(limit: number, lastKey?: string, User?:any): Observable<ApiResponse> {
    const cacheKey = lastKey || 'initial';

      const headers = new HttpHeaders().set('x-user-id', User);
      console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA")
      console.log(User)
    // Retornar observable en cache si existe
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey)!;
    }

    const params = new HttpParams()
      .set('limit', limit.toString())
      .set('lastKey', lastKey || '');

    const request$ = this.http.get<ApiResponse>(this.apiadmin, { params, headers}).pipe(
      shareReplay(1) // Compartir la misma suscripción
    );

    this.cache.set(cacheKey, request$);
    return request$;
  }


    getHostingsByidRecepcion(limit: number, lastKey?: string, User?:any): Observable<ApiResponse> {
    const cacheKey = lastKey || 'initial';

      const headers = new HttpHeaders().set('x-user-id', User);
      console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA")
      console.log(User)
    // Retornar observable en cache si existe
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey)!;
    }

    const params = new HttpParams()
      .set('limit', limit.toString())
      .set('lastKey', lastKey || '');

    const request$ = this.http.get<ApiResponse>(this.apiRecepcion, { params, headers }).pipe(
    catchError((error) => {
      console.error('API Error:', error);
      if (error.status === 0) {
        console.error('CORS Error - Check your API Gateway configuration');
      }
      return throwError(() => error);
    }),
    shareReplay(1)
  );

    this.cache.set(cacheKey, request$);
    return request$;
  }


  getHostingsForUser(limit: number, lastKey?: string, userId?: any): Observable<any> {
  return this.getHostingsByid(limit, lastKey, userId).pipe(
    switchMap((response: any) => {
      // Assume your backend returns an array of { host_id: string }
      const hostIds = response.map((h: any) => h.host_id);

      console.log('🧩 Found host IDs:', hostIds);

      // Create one request per host ID
      const requests = hostIds.map((id: string) => this.getHosting(id));

      // Combine them all into one observable that emits an array of Hosting objects
      return forkJoin(requests);
    })
  );
}


  getHostingsForUserRecepcion(limit: number, lastKey?: string, userId?: any): Observable<any> {
  return this.getHostingsByidRecepcion(limit, lastKey, userId).pipe(
    switchMap((response: any) => {
      // Assume your backend returns an array of { host_id: string }
      const hostIds = response.map((h: any) => h.host_id);

      console.log('🧩 Found host IDs:', hostIds);

      // Create one request per host ID
      const requests = hostIds.map((id: string) => this.getHosting(id));

      // Combine them all into one observable that emits an array of Hosting objects
      return forkJoin(requests);
    })
  );
}


  // Obtener un hosting  por ID (el ID es el índice en la base de datos)
  getHosting(id: string): Observable<Hosting>{
    return this.http.get<Hosting>(`${this.apiUrl}/${id}`);
  }

  // 🆕 Obtener TODOS los hostings (sin límite) usando paginación
  async getAllHostings(): Promise<Hosting[]> {
    const allHostings: Hosting[] = [];
    let lastKey: string | undefined = undefined;
    let hasMore = true;
    const pageSize = 50; // Tamaño de página para cada request

    console.log('🏨 Cargando TODOS los hostings...');

    while (hasMore) {
      try {
        const response: ApiResponse = await lastValueFrom(this.getHostings(pageSize, lastKey));

        if (response?.items) {
          allHostings.push(...response.items);
          lastKey = response.lastKey;
          hasMore = response.hasMore;

          console.log(`📄 Página cargada: ${response.items.length} hoteles. Total hasta ahora: ${allHostings.length}`);
        } else {
          hasMore = false;
        }
      } catch (error) {
        console.error('❌ Error cargando página de hostings:', error);
        hasMore = false;
      }
    }

    console.log(`✅ Total de hostings cargados: ${allHostings.length}`);
    return allHostings;
  }


  async getAllHostingId(): Promise<Hosting[]> {

    let user :any= await this.authservice.getUser();

    const allHostings: Hosting[] = [];
    let lastKey: string | undefined = undefined;
    let hasMore = true;
    const pageSize = 50; // Tamaño de página para cada request

    while (hasMore) {
      try {
      const userId = user.user?.id || '';
        const respons: ApiResponse = await lastValueFrom(this.getHostingsForUser(pageSize, lastKey,userId));
        let response:any;
        response= respons;
        console.log(response)
        if (response.length>0) {
          const validItems = response.filter((item: any) => item != null);
          allHostings.push(...validItems);
          lastKey = response.lastKey;
          hasMore = response.hasMore;
          console.log(`📄 Página cargada: ${response.length} hoteles. Total hasta ahora: ${allHostings.length}`);
        } else {
          hasMore = false;
        }
      } catch (error) {
        console.error('❌ Error cargando página de hostings:', error);
        hasMore = false;
      }
    }

    console.log(`✅ Total de hostings cargados: ${allHostings.length}`);
    return allHostings;
  }

  async getAllHostingIdRecepcion(): Promise<Hosting[]> {

    let user :any= await this.authservice.getUser();  // { id: 'abc123', name: 'John', ... }
    console.log(user)
    const allHostings: Hosting[] = [];
    let lastKey: string | undefined = undefined;
    let hasMore = true;
    const pageSize = 50; // Tamaño de página para cada request

    console.log('🏨 Cargando TODOS los hostings...');
     console.log(user);

    while (hasMore) {
      try {
      const userId = user.user?.id || '';
        const respons: ApiResponse = await lastValueFrom(this.getHostingsForUserRecepcion(pageSize, lastKey,userId));
        let response:any;
        response= respons;
        console.log(response)
        if (response.length>0) {
          const validItems = response.filter((item: any) => item != null);
          allHostings.push(...validItems);
          lastKey = response.lastKey;
          hasMore = response.hasMore;
          console.log(`📄 Página cargada: ${response.length} hoteles. Total hasta ahora: ${allHostings.length}`);
        } else {
          hasMore = false;
        }
      } catch (error) {
        console.error('❌ Error cargando página de hostings:', error);
        hasMore = false;
      }
    }

    console.log(`✅ Total de hostings cargados: ${allHostings.length}`);
    return allHostings;
  }


  // 🆕 Obtener habitaciones ocupadas en un rango de fechas
  getOccupiedRooms(checkIn: string, checkOut: string): Observable<OccupiedRoomsResponse> {
    const params = new HttpParams()
      .set('check_in', checkIn)
      .set('check_out', checkOut);

    return this.http.get<OccupiedRoomsResponse>(this.availabilityUrl, { params });
  }

  // 🆕 Filtrar hoteles disponibles basado en fechas
  async getAvailableHostings(checkIn: string, checkOut: string): Promise<Hosting[]> {
    try {
      console.log('🔍 Iniciando búsqueda de disponibilidad...');

      // 1. Obtener habitaciones ocupadas del backend
      console.log('📅 Consultando habitaciones ocupadas...');
      const occupiedResponse = await lastValueFrom(this.getOccupiedRooms(checkIn, checkOut));

      // 2. Obtener TODOS los hoteles de DynamoDB (sin límite)
      console.log('🏨 Cargando todos los hoteles...');
      const allHostings = await this.getAllHostings();

      if (!allHostings || !occupiedResponse) {
        throw new Error('Error obteniendo datos del servidor');
      }

      // 3. Filtrar hoteles que tengan habitaciones disponibles
      const availableHostings = allHostings.filter(hotel => {
        // Verificar si este hotel NO está en la lista de ocupados
        const isHotelOccupied = occupiedResponse.occupied_rooms.some(occupied =>
          occupied.hotel_id === hotel.id
        );

        // Solo incluir hoteles que NO estén ocupados
        return !isHotelOccupied;
      });

      console.log(`🎯 Resultado de búsqueda de disponibilidad:
📅 Fechas: ${checkIn} - ${checkOut}
🏨 Total hoteles en base de datos: ${allHostings.length}
❌ Hoteles ocupados: ${occupiedResponse.total_occupied_rooms}
✅ Hoteles disponibles: ${availableHostings.length}

📋 Hoteles ocupados:`,
        occupiedResponse.occupied_rooms.map(room => `${room.hotel_id}`).join(', ')
      );

      return availableHostings;

    } catch (error) {
      console.error('❌ Error obteniendo hoteles disponibles:', error);
      // Fallback: devolver todos los hoteles si hay error
      console.log('🔄 Usando fallback: cargando todos los hoteles...');
      const fallbackHostings = await this.getAllHostings();
      return fallbackHostings || [];
    }
  }

   // Crear un nuevo alojamiento
  // Método de prueba: envía un payload mínimo válido para aislar errores
  createHostingMinimal(): Observable<any> {
    const minimal: any = {
      id: `hosting-${Date.now()}`,
      name: 'Alojamiento de Prueba',
      type: 'Cabaña',
      email: 'test@example.com',
      phone: '3000000000',
      capacity: 1,
      description: 'Prueba mínima',
      rooms: [
        { id: `room-${Date.now()}`, name: 'Hab 1', capacity: 1, cost: 1 }
      ],
      included_services: [{ name: 'Wi-Fi' }],
      extra_services: [],
      payment_methods: ['Efectivo'],
      images: [],
      location: { full_address: '', coordinates: '' },
      updated_at: new Date().toISOString(),
    };

    return this.http.post(environment.hostingApiUrl, minimal).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('POST /hosting (minimal) error:', {
          status: err.status,
          statusText: err.statusText,
          url: err.url,
          error: err.error,
          payload: minimal,
        });
        return throwError(() => err);
      })
    );
  }
  createHosting(hosting: any) {

  const mappedHosting: any = {
    // =========================
    // IDs
    // =========================
    id: hosting.id || `hosting-${Date.now()}`,

    // =========================
    // DATOS BÁSICOS
    // =========================
    name: hosting.name,
    email: hosting.email,
    phone: hosting.phone,
    type: hosting.type,
    description: hosting.description || '',
    capacity: Number(hosting.capacity || 0),

    // =========================
    // UBICACIÓN
    // =========================
    location: {
      full_address: hosting.location?.full_address || '',
      coordinates: hosting.location?.coordinates || '',
      latitude: hosting.location?.latitude || '',
      longitude: hosting.location?.longitude || '',
      city: hosting.location?.city || '',
      country: hosting.location?.country || '',
      region: hosting.location?.region || '',
    },

    // =========================
    // IMÁGENES
    // =========================
    images: Array.isArray(hosting.images) ? hosting.images : [],

    // =========================
    // 🔥 SPACES → ROOMS (CLAVE)
    // =========================
    rooms: Array.isArray(hosting.spaces)
      ? hosting.spaces.map((s: any) => ({
          id: s.id,
          number: Number(s.number),
          type: s.type,
          floor: Number(s.floor),
          beds: Number(s.beds),
          bathrooms: Number(s.bathspaces), // 👈 FIX
          capacity: Number(s.capacity),
          price_per_night: Number(s.price_per_night),
          description: s.description || '',
          images: Array.isArray(s.images) ? s.images : [],
        }))
      : [],

    // =========================
    // SERVICIOS EXTRA
    // =========================
    extra_services: Array.isArray(hosting.extra_services)
      ? hosting.extra_services.map((e: any) => ({
          name: e.name,
          cost: Number(e.cost),
        }))
      : [],

    // =========================
    // SERVICIOS INCLUIDOS
    // =========================
    included_services: Array.isArray(hosting.included_services)
      ? hosting.included_services.map((i: any) => ({
          name: i.name,
          icon: i.icon || 'check',
        }))
      : [],

    // =========================
    // 🔥 MÉTODOS DE PAGO (OBJETO)
    // =========================
    payment_methods: Array.isArray(hosting.payment_methods)
      ? hosting.payment_methods.map((m: any) => ({
          name: m,
        }))
      : [],

    // =========================
    // USUARIO
    // =========================
    user_id: hosting.user_id,

    // =========================
    // FECHA
    // =========================
    updated_at: new Date().toISOString(),
  };

  console.log('✅ BODY FINAL CORRECTO:', mappedHosting);

  return this.http.post<Hosting>(this.apiUrl, mappedHosting).pipe(
    catchError((error) => {
      console.error('❌ Error creando alojamiento:', {
        status: error?.status,
        body: error?.error,
        payload: mappedHosting,
      });
      return throwError(() => error);
    })
  );
}


  // Actualizar un alojamiento existente
  updateHosting(id: string, hosting: Hosting) {
    return this.http.put<Hosting>(`${this.apiUrl}/${id}`, hosting);
  }

  // Eliminar un alojamiento
  deleteHosting(id: string){
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  // Obtener alojamientos por un array de IDs
  async getHostingsByIds(ids: string[]): Promise<Hosting[]> {
    if (!ids || ids.length === 0) return [];
    // Cargar todos y filtrar (optimizar si hay endpoint en backend)
    const allHostings = await this.getAllHostings();
    return allHostings.filter(h => ids.includes(h.id));
  }


  async getHostingsByAdminIds(): Promise<Hosting[]> {
    const allHostings = await this.getAllHostingId();
    return allHostings;
  }

}
